
<ul class="menu-nav" [ngClass]="ulCSSClasses">
  <li class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder font-weight-bold" routerLink="/home" routerLinkActive="active">
      <span class="menu-text text-company font-weight-bolder uppercase"><i class="fa  fa-home"></i></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerPolizas == 1"  class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder"  routerLink="/list-insurance">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.INSURANCE"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerEnviarDocumentosPoliza == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/send-policy-documents">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.SEND_DOCUMENTS_POLICY"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerCargarDocumentos == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/list-documents">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.DOCUMENTS"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerSolicitud == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/request">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.PAYMENT_REQUEST"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <!--li *ngIf="permissionMenu.VerSolicitudEndosos == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/list-request">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.REQUEST"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li -->

   <!--
  <li *ngIf="permissionMenu.VerQuote == 1 && cotizadorLink" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" href="{{cotizadorLink}}" target="_blank">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.QUOTER"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>
  -->

  <li *ngIf="permissionMenu.VerQuote == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/quotes">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.QUOTES"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerCotizacion == 1" 
    [attr.data-menu-toggle]="headerMenuDesktopToggle"
    aria-haspopup="true"
    class="menu-item menu-item-submenu menu-item-rel"
    (click)="openDropdowm('menu-item-subnav-quotes')"
  >
    <a class="menu-link menu-toggle font-weight-bolder" href="#">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.QUOTES"></span>
        <i class="menu-arrow"></i>
    </a>
    <div id="menu-item-subnav-quotes" class="menu-submenu menu-submenu-classic menu-submenu-left" style="display: none;">
        <ul class="menu-subnav">
            <li
            class="menu-item menu-item-submenu"
            data-menu-toggle="hover"
            aria-haspopup="true"
            >
            <a *ngIf="permissionMenu.VerCotizacionVida==1" class="menu-link" href="/quotes-life"  
                ><span class="menu-text font-weight-bolder uppercase" translate="QUOTES.QUOTESOFLIFE"></span></a
            >
            </li>

            <li
            class="menu-item menu-item-submenu"
            data-menu-toggle="hover"
            aria-haspopup="true"
            >
            <a  *ngIf="permissionMenu.VerEvaluacionCotizacionVida==1" class="menu-link" href="/quotes-life-cz"  
                ><span class="menu-text font-weight-bolder uppercase" translate="QUOTES.QUOTESCZ"></span></a
            >
            </li>
        </ul>
      </div>
  </li>

  <li *ngIf="permissionMenu.VerReclamos == 1" 
    id="menu-item-submenu-reclamos"
   [attr.data-menu-toggle]="headerMenuDesktopToggle"
    aria-haspopup="true"
    class="menu-item menu-item-submenu menu-item-rel"
    (click)="openDropdowm('menu-item-subnav-reclamos')"

  >
    <a class="menu-link menu-toggle font-weight-bolder" >
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.CLAIMS"></span>
        <i class="menu-arrow"></i>
    </a>
    <div id="menu-item-subnav-reclamos" class="menu-submenu menu-submenu-classic menu-submenu-left" style="display: none;">
        <ul class="menu-subnav">
            <li
            class="menu-item menu-item-submenu"
            data-menu-toggle="hover"
            aria-haspopup="true"
            >
            <a *ngIf="permissionMenu.VerNotificarReclamos==1" class="menu-link" routerLink="/create-claim"  
                ><span class="menu-text font-weight-bolder uppercase" translate="CLAIMS.CREATE_CLAIMS"></span></a
            >
            </li>

            <li
            class="menu-item menu-item-submenu"
            data-menu-toggle="hover"
            aria-haspopup="true"
            >
            <a  *ngIf="permissionMenu.VerConsultarReclamos==1" class="menu-link" routerLink="/list-claims"  
                ><span class="menu-text font-weight-bolder uppercase" translate="CLAIMS.LIST_CLAIMS"></span></a
            >
            </li>
        </ul>
      </div>
  </li>
  
  <!--li *ngIf="permissionMenu.VerReclamos == 1" class="menu-item dropdown" ngbDropdown>
        <a class="menu-link font-weight-bolder dropdown-toggle" id="dropdownMenuButtonCLAIMS" ngbDropdownToggle>
            <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.CLAIMS"></span>
            <i class="fa fa-arrow" style="display: flex!important;"></i>
        </a>
        <div ngbDropdownMenu aria-labelledby="dropdownMenuButtonCLAIMS">
            <a class="dropdown-item" *ngIf="permissionMenu.VerNotificarReclamos==1" routerLink="/create-claim" ><span class="menu-text text-company font-weight-bolder uppercase"  translate="CLAIMS.CREATE_CLAIMS"></span></a>
            <a class="dropdown-item" *ngIf="permissionMenu.VerConsultarReclamos==1" routerLink="/list-claim" ><span class="menu-text text-company font-weight-bolder uppercase"  translate="CLAIMS.LIST_CLAIMS"></span></a>
        </div>
  </li -->

  <li *ngIf="permissionMenu.VerInformes == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/list-estatements">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.ACCOUNT_ESTATEMENTS"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerFormularios == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/list-documents-form">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.DOCUMENT_FORMS"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>

  <li *ngIf="permissionMenu.VerPagoPoliza == 1" class="menu-item menu-item-rel" >
    <a class="menu-link font-weight-bolder" routerLink="/payments">
      <span class="menu-text text-company font-weight-bolder uppercase" translate="MENU.PAYMENTS"></span>
      <ng-container *ngIf="rootArrowEnabled">
        <i class="menu-arrow"></i>
      </ng-container>
    </a>
  </li>
</ul>